module.exports = __webpack_public_path__ + "img/promote-your-music-on-websites.4d796297.jpg";